"use client";
import { FC } from "react";
import { Transition } from "@headlessui/react";
import SVGIcon from "./SVGIcon";
import classNames from "classnames";
import Modal from "./Modal";

type Props = {
  children: JSX.Element[] | JSX.Element;
  className?: string;
  size?: string;
  onClose?: () => void;
  isOpen?: boolean;
};

const SearchModal: FC<Props> = ({
  children,
  className,
  size,
  onClose = () => {},
  isOpen = false,
}) => {
  return (
    <Modal
      className="!p-0 rounded-none sm:rounded max-w-full sm:max-w-[calc(100dvw-64px)] xl:max-w-[1264px] sm:!top-[64px] sm:!translate-y-0 xl:-translate-x-[calc(50%-32px)] !bg-tertiary-50 dark:!bg-tertiary shadow-base"
      size="large"
      onClose={onClose}
      isOpen={isOpen}
      showCloseButton={false}
    >
      <div
        className={classNames(
          `px-4 py-6 sm:p-10 rounded top-0 relative border-none sm:border-tertiary-300/50 dark:border-tertiary-800/75 border `,
          className
        )}
      >
        {children}
      </div>
    </Modal>
  );
};

export default SearchModal;
